import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";

// F-device-enforcement · 2026-08-24
// Slice para el panel admin de gestión de dispositivos activos +
// enforcement remoto (asignar empleado forzado, requerir selección).
// El TPV en sí no consume este slice — reacciona directamente al hub.

const initialState = {
  isLoading: false,
  items: [],
  error: null,
};

const slice = createSlice({
  name: "devicesEnforcement",
  initialState,
  reducers: {
    startLoading(state) { state.isLoading = true; state.error = null; },
    hasError(state, action) { state.isLoading = false; state.error = action.payload; },
    setItems(state, action) {
      state.isLoading = false;
      state.items = action.payload || [];
    },
    // Aplicamos el update localmente sin volver a fetch tras assign/require.
    // Idempotente por device.id.
    upsertItem(state, action) {
      const payload = action.payload;
      if (!payload?.id) return;
      const idx = state.items.findIndex((x) => x.id === payload.id);
      if (idx >= 0) {
        state.items[idx] = { ...state.items[idx], ...payload };
      }
    },
  },
});

export default slice.reducer;

export function getActiveDevices() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const res = await axios.get("/devices/active");
      dispatch(slice.actions.setItems(res.data || []));
    } catch (err) {
      dispatch(slice.actions.hasError(err?.message || "Error"));
    }
  };
}

// employeeId=null → desasignar. Backend emite SignalR al device.
export function assignDeviceEmployee(deviceId, employeeId) {
  return async (dispatch) => {
    try {
      const res = await axios.post(`/devices/${deviceId}/assign-employee`, {
        employeeId: employeeId ?? null,
      });
      dispatch(slice.actions.upsertItem({
        id: deviceId,
        assignedEmployeeId: res.data?.assignedEmployeeId ?? null,
      }));
      return true;
    } catch (err) {
      dispatch(slice.actions.hasError(err?.response?.data?.message || err?.message || "Error"));
      return false;
    }
  };
}

export function setDeviceRequireSelection(deviceId, require) {
  return async (dispatch) => {
    try {
      const res = await axios.post(`/devices/${deviceId}/require-selection`, { require });
      dispatch(slice.actions.upsertItem({
        id: deviceId,
        requireEmployeeSelection: !!res.data?.requireEmployeeSelection,
      }));
      return true;
    } catch (err) {
      dispatch(slice.actions.hasError(err?.response?.data?.message || err?.message || "Error"));
      return false;
    }
  };
}

// 2026-08-24 · One-shot: fuerza al TPV que abra el kiosko AHORA.
// No persiste estado — puede pulsarse N veces si el TPV lo cerró.
// Sustituye al patrón anterior de switch sticky.
export function forceDeviceEmployeeSelection(deviceId) {
  return async (dispatch) => {
    try {
      await axios.post(`/devices/${deviceId}/force-selection`);
      return true;
    } catch (err) {
      dispatch(slice.actions.hasError(err?.response?.data?.message || err?.message || "Error"));
      return false;
    }
  };
}

// 2026-09-09 · Fuerza selección de empleado en TODOS los dispositivos
// activos del restaurante EXCEPTO el actual (backend lo excluye por
// el header SessionIdentifier — axios interceptor lo pega ya).
// Devuelve el número de dispositivos notificados.
export function forceAllDevicesSelection() {
  return async (dispatch) => {
    try {
      const res = await axios.post("/devices/force-selection-all");
      return res.data?.notified ?? 0;
    } catch (err) {
      dispatch(slice.actions.hasError(err?.response?.data?.message || err?.message || "Error"));
      throw err;
    }
  };
}
